import { Link, useSearchParams } from 'react-router-dom';
import villeIcon from '../../assets/images/ville.svg';
import listsIcon from '../../assets/images/lists.svg';
import UserSettings from '../../assets/icons/userSetti.svg';
import {
  buildAdminPathWithScope,
  normalizeAdminScope
} from '../../utils/adminScope';
import './style.scss';

function AdminMenu() {
  const [searchParams] = useSearchParams();
  const isDividedSelection = searchParams.get('view') === 'divided';
  const adminScope = normalizeAdminScope(searchParams.get('scope'));
  const isCopScope = adminScope === 'cop';
  const isSocialControlScope = adminScope === 'cs';
  const hasEvidenceWorkspace =
    adminScope === 'general' || adminScope === 'diplom' ||
    adminScope === 'ndn' || adminScope === 'cop';
  const showAttendancesCard = adminScope !== 'cop';
  const dashboardPath = buildAdminPathWithScope(
    '/administrador/avances',
    adminScope
  );

  const schoolsPath = buildAdminPathWithScope(
    '/administrador/menu/escuelas',
    adminScope
  );
  const attendancesPath = buildAdminPathWithScope(
    '/administrador/menu/asistencias',
    adminScope
  );
  const evidencesPath = buildAdminPathWithScope(
    '/administrador/menu/evidencias',
    adminScope
  );
  const mountEvidencePath = buildAdminPathWithScope(
    '/administrador/menu/montar-evidencias',
    adminScope
  );
  const calendarPath = buildAdminPathWithScope(
    '/administrador/menu/calendario',
    adminScope
  );
  const characterizationPath = buildAdminPathWithScope(
    '/administrador/menu/caracterizacion',
    adminScope
  );

  if (isDividedSelection) {
    return (
      <section className='menuAdmin-main-container'>
        <div className='menuAdmin-shell menuAdmin-shell--process-selection'>
          <div className='process-selection'>
            <div className='process-selection__heading'>
              <h1>Selecciona el proceso formativo</h1>
              <p>
                Elige el proceso cuya informacion deseas consultar y gestionar.
              </p>
            </div>

            <div className='process-selection__options'>
              <Link
                to={buildAdminPathWithScope('/administrador/menu', 'pf')}
                className='process-selection__option'>
                <span className='material-symbols-rounded' aria-hidden='true'>
                  school
                </span>
                <strong>Escuelas de Participacion</strong>
                <small>Ver proceso formativo, asistencias, evidencias y demas opciones.</small>
              </Link>

              <Link
                to={buildAdminPathWithScope('/administrador/menu', 'ndn')}
                className='process-selection__option process-selection__option--ndn'>
                <span className='material-symbols-rounded' aria-hidden='true'>
                  map
                </span>
                <strong>Nada de Nervios</strong>
                <small>Ver proceso formativo, asistencias, evidencias y demas opciones.</small>
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className='menuAdmin-main-container'>
      <div className='menuAdmin-shell'>
        <div className='menuAdmin-toolbar'>
          <Link to={dashboardPath} className='menuAdmin-dashboard-button'>
            Panel del Proceso
          </Link>
        </div>

        <div className='option-general-container'>
          <Link to={schoolsPath} className='option-container'>
            <div className='image-container'>
              <img src={villeIcon} alt='' />
            </div>
            <p className='description'>
              {isCopScope
                ? 'Consulta y actualiza Asesorías segun dependencia o mediador'
                : 'Crea y actualiza Proceso Formativo segun comuna o mediador'}
            </p>
            <p className='title'>{isCopScope ? 'ASESORÍA' : 'PROCESO FORMATIVO'}</p>
          </Link>

          {hasEvidenceWorkspace && (
            <Link to={mountEvidencePath} className='option-container'>
              <div className='image-container'>
                <img src={listsIcon} alt='' />
              </div>
              <p className='description'>
                Gestiona evidencias de concertacion y socializacion.
              </p>
              <p className='title'>MONTAR EVIDENCIAS</p>
            </Link>
          )}

          {showAttendancesCard && (
            <Link to={attendancesPath} className='option-container'>
              <div className='image-container'>
                <img src={listsIcon} alt='' />
              </div>
              <p className='description'>
                Verifica y guarda la asistencia de los beneficiarios a los
                encuentros programados.
              </p>
              <p className='title'>ASISTENCIAS</p>
            </Link>
          )}

          {!isSocialControlScope && (
            <Link to={calendarPath} className='option-container'>
              <div className='image-container'>
                <span className='material-symbols-rounded' aria-hidden='true'>
                  calendar_month
                </span>
              </div>
              <p className='description'>
                Consulta y programa la agenda del proceso seleccionado.
              </p>
              <p className='title'>CALENDARIO</p>
            </Link>
          )}

          {!isSocialControlScope && (
            <Link to={evidencesPath} className='option-container'>
              <div className='image-container'>
                <img src={listsIcon} alt='' />
              </div>
              <p className='description'>
                Gestiona evidencias de concertacion y socializacion.
              </p>
              <p className='title'>EVIDENCIAS</p>
            </Link>
          )}

          <Link to={characterizationPath} className='option-container'>
            <div className='image-container'>
              <img src={UserSettings} alt='' />
            </div>
            <p className='description'>
              Busca o ingresa nuevos usuarios a la plataforma
            </p>
            <p className='title'>CARACTERIZACION</p>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default AdminMenu;
